import React from 'react';
import PropTypes from 'prop-types';

function formatBytes(bytes) {
  if (typeof bytes !== 'number') return '';
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
}

// One file in the composer's attachment list. `state` is reply-level (all items share it):
// idle (composing), sending (reply in flight -- locked), or failed (reply failed -- offer retry).
function AttachmentItem({
  filename, bytes = null, state = 'idle', onRemove, onRetry,
}) {
  const sending = state === 'sending';
  const failed = state === 'failed';

  return (
    <div className={`card p-3 ${failed ? 'border-danger' : ''}`}>
      <div className="d-flex align-items-start gap-2">
        <i className={`fa-file ${failed ? 'fa-solid text-danger' : 'fa-light text-secondary'}`} aria-hidden="true" />
        <div className="flex-grow-1 overflow-hidden">
          <div className="fw-semibold text-truncate">{filename}</div>
          <div className="text-secondary small">{failed ? 'Upload failed, please try again' : formatBytes(bytes)}</div>

          {sending && (
            <div className="progress mt-2" role="progressbar" aria-label={`Sending ${filename}`} style={{ height: 6 }}>
              <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: '100%' }} />
            </div>
          )}

          {failed && (
            <button type="button" className="btn btn-link btn-sm p-0 mt-2 text-decoration-none" onClick={onRetry}>
              <i className="fa-solid fa-rotate-right me-1" /> Try again
            </button>
          )}
        </div>

        <button
          type="button"
          className="btn btn-link p-0 text-danger"
          aria-label={`Remove ${filename}`}
          onClick={onRemove}
          onMouseDown={(e) => e.preventDefault()}
          disabled={sending}
        >
          <i className="fa-light fa-trash" />
        </button>
      </div>
    </div>
  );
}

AttachmentItem.propTypes = {
  filename: PropTypes.string.isRequired,
  bytes: PropTypes.number,
  state: PropTypes.oneOf(['idle', 'sending', 'failed']),
  onRemove: PropTypes.func,
  onRetry: PropTypes.func,
};

export default AttachmentItem;
